import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [
		RouterModule.forRoot([], {
			onSameUrlNavigation: 'reload',
			relativeLinkResolution: 'legacy',
			initialNavigation: 'disabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRouterModule {}
